// BlogPreviewSkeleton.jsx
import React from "react";

const BlogPreviewSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-10 animate-pulse">

      {/* BACK BUTTON */}
      <div className="h-10 bg-gray-300 rounded w-40 mb-6"></div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

        {/* BLOG CONTENT */}
        <div className="md:col-span-2 bg-white rounded-lg shadow overflow-hidden">

          {/* IMAGE */}
          <div className="w-full h-96 bg-gray-300"></div>

          <div className="p-6">

            {/* TITLE */}
            <div className="h-6 bg-gray-300 rounded w-3/4 mb-4"></div>

            {/* CATEGORY */}
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-6"></div>

            {/* CONTENT LINES */}
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className="h-4 bg-gray-200 rounded mb-3 w-full"
              ></div>
            ))}

            {/* TAGS */}
            <div className="mt-6 flex gap-2 flex-wrap">
              {[...Array(4)].map((_, i) => (
                <div
                  key={i}
                  className="h-6 w-16 bg-gray-300 rounded"
                ></div>
              ))}
            </div>

          </div>
        </div>

        {/* SIDEBAR */}
        <div className="md:col-span-1">
          <div className="bg-white rounded-lg shadow p-4">

            {/* TITLE */}
            <div className="h-5 bg-gray-300 rounded w-32 mb-4"></div>

            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex gap-3 mb-4">
                <div className="w-16 h-16 bg-gray-300 rounded"></div>

                <div className="flex-1">
                  <div className="h-3 bg-gray-300 rounded w-3/4 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </div>
  );
};

export default BlogPreviewSkeleton;